let slicktype = "";
const breakPoint = 768;
$(function () {
	$(".slide").slick({
		variableWidth: true, // スライド幅の自動計算を無効化
		arrows: false,
		autoplay: true,
		swipeToSlide: true,
		touchThreshold: 10,
		speed: 500,
		autoplaySpeed: 4e3,
		adaptiveHeight: false,
		dots: false,
		slidesToShow: 1,
		pauseOnHover: !1,
		pauseOnFocus: !1,
	});
	$(".slider").slick({
		variableWidth: true, // スライド幅の自動計算を無効化
		arrows: true,
		autoplay: true,
		swipeToSlide: true,
		touchThreshold: 10,
		speed: 500,
		autoplaySpeed: 4e3,
		adaptiveHeight: false,
		dots: false,
		slidesToShow: 1,
		pauseOnHover: !1,
		pauseOnFocus: !1,
	});

	// スクロールのオフセット値
	var offsetY = -10;
	// スクロールにかかる時間
	var time = 500;

	// ページ内リンクのみを取得
	$('a[href^="#"]').click(function () {
    if(this.classList.contains('no-scroll') === false && this.classList.contains('BIS_trigger') === false){ 
      // スクロールの速度
      var speed = 400; // ミリ秒
      // アンカーの値取得
      var href = $(this).attr("href");
      // 移動先を取得
      var target = $(href == "#" || href == "" ? "html" : href);
      // 移動先を数値で取得
      var position = target.offset().top;
      // スムーススクロール
      $("body,html").animate({ scrollTop: position }, speed, "swing");
      return false;
    }
	});

	//初期設定
	var settings = {
		speed: 10000, //速さ
		freq: 10000, //ゆらぎ（上記速さに「Math.random()*この値」を加算して速さをバラバラにする）
	};

	//アニメーション
	var cloud = function (obj, settings, winsize) {
		var imgw = obj.width();

		//横スクロールが発生しないように親要素の幅をウィンドウサイズと同じにして、overflow:hiddenする
		obj.closest("ul").css({
			width: winsize.winw + "px",
			height: winsize.winh + "px",
		});

		//アニメーション実行
		obj.animate(
			{
				left: winsize.winw + "px",
			},
			{
				eeasing: "swing",
				duration: settings.speed + settings.freq * Math.random(),
				complete: function () {
					//アニメーション終了後、画面外に戻す。
					//縦方向はランダムにする（ここではbodyかwindowの高さの大きい方以内でバラバラにしています）
					obj.css({
						left: -1 * imgw + "px",
						bottom: Math.floor(Math.random() * winsize.winh) + "px",
					});
					//再帰処理
					cloud(obj, settings, winsize);
				},
			},
		);
	};
	var winsize = {
		winw: Math.max($("html").width(), $("body").width(), $(window).width()),
		winh: $(".mv_animation").height(),
	};

	//雲の初期配置。ランダムにしてバラバラな位置から始まるようにする
	$("ul.cloud li").each(function (key, value) {
		//縦方向の位置設定。画面内に収まる範囲でランダムに。
		var randv = Math.floor(Math.random() * winsize.winh);

		//横方向の位置設定。画面内に収まる範囲でランダム
		var randh = Math.floor(Math.random() * winsize.winw) - winsize.winw;

		$(this).css({
			bottom: randv + "px",
			left: randh + "px",
		});

		//アニメーション実行
		cloud($(this), settings, winsize);
	});

	//ウインドウリサイズ時の処理
	$(window).on("load resize", function () {
		//画面サイズを取り直す
		var winsize = {
			winw: Math.max($("html").width(), $("body").width(), $(window).width()),
			winh: $(".mv_animation").height(),
		};

		$("ul.cloud li").each(function (key, value) {
			$(this).stop(true, false);
			cloud($(this), settings, winsize);
		});
	});

	heartMaker(100);
});
function heartMaker(n) {
	var heart = document.createElement("div");
	var addclass = "";
	heart.className = "heart";
	heart.textContent = "";
	for (var i = 0; i < n; i++) {
		addclass =
			"heart_" + ("0" + (1 + Math.floor(Math.random() * 17))).slice(-2);
		heart.classList.add(addclass);
		if (i % 2 == 0) {
			heart.classList.add("r");
		}
		heartSet(heart);
		heart.classList.remove(addclass);
	}
}
function heartSet(clone) {
	var heartClone = clone.cloneNode(true);
	var heartStyle = heartClone.style;
	var addclass = "";

	//ハートの位置（left）、アニメーションの遅延時間（animation-delay）、サイズ（font-size）をランダムで指定
	heartStyle.left = 80 * Math.random() + "%";
	heartStyle.animationDelay = 60 * Math.random() + "s";
	heartStyle.animationDuration =
		2 + 5 * Math.random() + "s" + "," + (20 + 60 * Math.random() + "s");
	//  heartStyle.animationDuration = (2+(5 * Math.random()) + "s")+","+(1+(1 * Math.random()) + "s");
	heartStyle.className =
		"heart" +
		" " +
		"heart_" +
		("0" + (1 + Math.floor(Math.random() * 17))).slice(-2);

	//  $('#lp_contents').append(heartClone);
	$(".heart_box").append(heartClone);

	//ハート一つのアニメーションが終わったら新しいハートを生成
	heartClone.addEventListener(
		"animationend",
		function () {
			this.parentNode.removeChild(this);
			var heart = document.createElement("div");
			heart.className = "heart";
			heart.textContent = "";

			addclass =
				"heart_" + ("0" + (1 + Math.floor(Math.random() * 17))).slice(-2);
			heart.classList.add(addclass);
			heartSet(heart);
			heart.classList.remove(addclass);
		},
		false,
	);
}